import type Message from "owa-service/lib/contract/Message";

export default function shouldDisabledReadReceipts(item: Message): boolean {
    return !item.IsReadReceiptRequested;
}
